export default __webpack_public_path__ + "static/leaderboard-fdf05b1ccb0c4b07cfc9b09b09f30340.png";